export { default as ChildInfo } from './ChildInfo';



// WEBPACK FOOTER //
// ./src/components/Admin/ChildInfo/index.js